import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BottomSheet } from '../../BottomSheet';
import { WheelPicker } from '../../WheelPicker';
import { ChevronIcon } from '../../ChevronIcon';
import { NumberSelectProps } from '../types';
import {
  MobileTriggerWrapper,
  PickerContent,
  PickerFooter,
  SaveButton,
  TriggerButton,
  TriggerLabel,
  TriggerTexts,
  TriggerValue
} from './styled';

const BOTTOM_SHEET_HEIGHT = 318;

export const NumberSelectMobile: React.FC<NumberSelectProps> = ({
  value,
  onChange,
  max,
  placeholder,
  title,
  disabledZero,
  error,
  cypress
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [pendingIndex, setPendingIndex] = useState(value ?? 0);

  const items = Array.from({ length: max + 1 }, (_, i) => String(i));

  const handleOpen = () => {
    const initial = value ?? 0;
    setPendingIndex(disabledZero && initial === 0 ? 1 : initial);
    setIsOpen(true);
  };

  const handleSave = () => {
    onChange(pendingIndex);
    setIsOpen(false);
  };

  return (
    <MobileTriggerWrapper>
      <TriggerButton
        type="button"
        $hasValue={value !== null}
        $isError={error}
        onClick={handleOpen}
        data-cy={cypress}
      >
        <TriggerTexts>
          {value !== null && (
            <TriggerLabel $isError={error}>{placeholder}</TriggerLabel>
          )}
          <TriggerValue $hasValue={value !== null}>
            {value !== null ? String(value) : placeholder}
          </TriggerValue>
        </TriggerTexts>
        <ChevronIcon />
      </TriggerButton>

      <BottomSheet
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={title ?? placeholder}
        height={BOTTOM_SHEET_HEIGHT}
      >
        <PickerContent>
          <WheelPicker
            items={items}
            selectedIndex={pendingIndex}
            onChange={setPendingIndex}
            disabledIndex={disabledZero ? 0 : undefined}
          />
        </PickerContent>
        <PickerFooter>
          <SaveButton
            type="button"
            onClick={handleSave}
            data-cy={cypress ? `${cypress}-save` : undefined}
          >
            {t('new_ad.save')}
          </SaveButton>
        </PickerFooter>
      </BottomSheet>
    </MobileTriggerWrapper>
  );
};
